export const createHydrogenUrls = <T extends string>(siteUrl: T) =>
  ({
    auth: {
      signup: `${siteUrl}/auth/signup` as const,
      login: `${siteUrl}/auth/login` as const,
    },
    dashboard: {
      home: `${siteUrl}/dashboard` as const,
      prescriptions: `${siteUrl}/dashboard/prescriptions` as const,
    },
    shop: `${siteUrl}/shop` as const,
  }) as const;
